/**
 * This class handles event listners' tracking and their clean-up. It is used to start and reset the timer for the time the user remains inactive.
 */
class IdleTimer {
    constructor({ onIdle, timeout }) {
        this.timeout = timeout;
        this.onIdle = onIdle;
        this.eventHandler = this.updateExpiredTime.bind(this);
    }

    start() {
        this.tracker();
        this.startInterval();
    }

    startInterval() {
        this.updateExpiredTime();
        this.interval = setInterval(() => {
            const expiredTime = parseInt(localStorage.getItem('_expiredTime'), 10);
            if (expiredTime < Date.now()) {
                if (this.onIdle) {
                    this.onIdle();
                    this.cleanUp();
                }
            }
        }, 1000);
    }

    updateExpiredTime() {
        if (this.timeoutTracker) {
            clearTimeout(this.timeoutTracker);
        }
        this.timeoutTracker = setTimeout(() => {
            localStorage.setItem('_expiredTime', Date.now() + this.timeout * 1000);
        }, 300);
    }

    tracker() {
        window.addEventListener('mousemove', this.eventHandler);
        window.addEventListener('scroll', this.eventHandler);
        window.addEventListener('keydown', this.eventHandler);
        window.addEventListener('touchstart', this.eventHandler);
        window.addEventListener('touchmove', this.eventHandler);
    }

    cleanUp() {
        clearInterval(this.interval);
        localStorage.removeItem('_expiredTime');
        window.removeEventListener('mousemove', this.eventHandler);
        window.removeEventListener('scroll', this.eventHandler);
        window.removeEventListener('keydown', this.eventHandler);
        window.removeEventListener('touchstart', this.eventHandler);
        window.removeEventListener('touchmove', this.eventHandler);
    }
}
export default IdleTimer;
